import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth/auth.service';
import { SnackbarService } from '../services/snackbar/snackbar.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  standalone: false,
})
export class LoginComponent implements OnInit {
  username = '';
  password = '';
  loading = false;

  constructor(
    private authService: AuthService,
    private snackbar: SnackbarService,
    private router: Router,
  ) {}

  async ngOnInit(): Promise<void> {
    if (await this.authService.ensureSession()) {
      this.router.navigate([this.authService.getDefaultRoute()]);
    }
  }

  async submit(): Promise<void> {
    if (!this.username || !this.password || this.loading) {
      return;
    }

    this.loading = true;

    try {
      await this.authService.login(this.username.trim(), this.password);
      this.router.navigate([this.authService.getDefaultRoute()]);
    } catch {
      this.snackbar.error('Usuario o contraseña incorrectos', {
        duration: 3000,
      });
    } finally {
      this.loading = false;
    }
  }
}
